module.exports = {
	"h1": {
		"ja": "目標管理,目標達成と習慣化のためのアプリ",
		"en": "App to Help You Achieve Your Goals and<br /> Build New Habits",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#header>p": {
		"ja": "自分へのご褒美を上手に使って目標達成",
		"en": "Stay Motivated & Achieve Your Goals with Reward Yourself",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#nav>ul>1": {
		"ja": "自分ルールポイントカードとは",
		"en": "Rewards Points for Achieving Your Goals",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#nav>ul>2": {
		"ja": "使い方",
		"en": "How to use",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#nav>ul>3": {
		"ja": "特徴",
		"en": "Features",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#nav>ul>4": {
		"ja": "始める",
		"en": "Start App",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#intro>div>div>p": {
		"ja": "自分ルールポイントカードは目標管理,目標達成と習慣化のための<br />アプリです.<br /><br />一般的なポイントシステムのように習慣化したい行動をポイント化して,<br />ポイントがたまったら自分へご褒美をあげて下さい.<br />例: 本を読んだ, 運動した.　等々で10ポイントを溜める.<br />　→1,000ポイント貯めたら,好きな物が食べられる.<br />\n<br />\n最初から大きな目標を目指すのではなく,小さな目標を毎日少しずつ<br />クリアしていく事で大きな目標の達成を行います.<br />\nそのた自分ルールポイントカードではまずは習慣化を目指します.<br /><br />このアプリではポイント管理のお手伝いさせて頂きます.<br />ポイントを貯める方法やご褒美(ポイントの消費方法）の内容は<br />ご自身で設定して頂けます.<br />",
		"en": "This is app to help you achieve your goals and build new habits.<br /><br />When you did good habit that you want to build, you give to yourself points. <br />You reward yourself with points, when you have enough point.<br /> e.g. You earn 10-point by reading books, getting exercise and more.<br /> And then you eat favorite food with 1,000-point. <br /><br />You make a big achievement by achieving your small goal every day.<br /> First of all, App help you build your good habits to make a your big achievement. <br />App manage reward point.<br /> you can set up redeem points(how to earn point) and reward(how to redeem point) by yourself.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:1>h3": {
		"ja": "小さな目標を決める",
		"en": "Set Small Goals",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:2>h3": {
		"ja": "習慣化する",
		"en": "Build Good Habits",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:3>h3": {
		"ja": "目標を達成",
		"en": "Achieve Big Goals",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:1>p": {
		"ja": "まずは大きな目標を達成するために小さな目標を決め,ポイント化し,日々実行するようにします.<br />例: 本を読んだ,運動した. 等々で10ポイントを溜める.<br />　何か新しい事を始めようとしても3日坊主で終わってしまう方,自分のやる気(モチベーション)が上がるようにご褒美(ポイントの消費方法）を上手く設定して下さい. <br /><br />- ヒント!! -<br />　小さな目標はいつ,どこで,どのように実行するのか,なるべく具体的に決めて行うようにします.<br />その方が習慣化が行いやすいとの事です.",
		"en": "First of all, You set small goal for achieving big goals. And achieve small goal every day. <br />e.g. You earn 10-point by reading books, getting exercise and more. <br /><br /> When you can't help to get bored of everything so quickly and easily,  stay motivated & achieve your goals by rewarding yourself. <br /><br /><br />- Hint!! -<br />　You are 2x to 3x more likely to follow through with a habit if you make a specific plan for when, where, and how you are going to implement it. ",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:2>p": {
		"ja": "　小さな目標を達成しポイントがたまったら,自分にご褒美をあげてください. <br />ポイントがなくなったら再度ポイントをため,達成したらご褒美をあげる.このサイクルを繰り返し行い小さな目標の習慣化を目指します.<br />最終的にはご褒美なしでも行動が行えるように、まずは行動の習慣化を目指しましょう. <br /><br />-ヒント-<br />　習慣化は1つの習慣に的を絞った方が良いとのことです.同時に複数の習慣を身につけようとすると実行意図の効果が出ないそうです.",
		"en": "When you have enough point, you reward yourself with points.<br />When you've used, get point again by achieving small goals.<br /><br />You repeat achieving small goal and rewarding yourself over and over again.<br />Eventually, you achieve small goal without rewards. App help you build your good habits<br /><br />- Hint!! -<br />　You should focus entirely on one habit. implementation intentions do not work if you try to improve multiple habits at the same time.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>ul>li:3>p": {
		"ja": "　小さな目標を無意識に,当たり前に行えるようにします. 実践すればするほど習慣が自動化されるとの事です.<br />いきなり大きな目標を達成しようとするのではなく小さな目標達成を繰り返し行うことで大きな目標を達成します.<br />日々の努力をゲーム感覚で楽しく行うことができます. 楽しみながら目標達成を行ってください.<br /><br />-ヒント-<br />　平均的には、新習慣が自動的な行動になるまでに少なくとも2カ月かかるそうです.",
		"en": "You will come to be able to achieve small goal on a daily basis. <br />Any given habit becomes more automatic with more practice..<br /><br /> You make a big achievement by achieving your small goal every day. <br />You achieve your goals as you play, so it's easy to make efforts.  <br /><br /><br />- Hint!! -<br />On average, it takes at least two months for new habits to become automatic behaviors.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>footer.tetx": {
		"ja": "参考にさせていただきました.",
		"en": "Reference",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>footer>ul>li:1>a.tetx": {
		"ja": "研究結果から判明した、新しい習慣を定着させる3つのルール | 訳：Lifehacker - 和田美樹",
		"en": "",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>footer>ul>li:1>a.link": {
		"ja": "http://www.lifehacker.jp/2016/08/160821science_master1.html",
		"en": "http://www.lifehacker.jp/2016/08/160821science_master1.html",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>footer>ul>li:2>a.tetx": {
		"ja": "The Scientific Argument for Mastering One Thing at a Time | James Clear",
		"en": "The Scientific Argument for Mastering One Thing at a Time | James Clear",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#first>footer>ul>li:2>a.link": {
		"ja": "http://jamesclear.com/master-one-thing",
		"en": "http://jamesclear.com/master-one-thing",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>header>p": {
		"ja": "自分ルールポイントプログラムは日々の努力を継続的に行うためのたくさんの機能があります.",
		"en": "App has five features for making continuous efforts every day.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>ul>li.style1": {
		"ja": "ポイント管理",
		"en": "Manage point",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>ul>li.style2": {
		"ja": "アファーメーション",
		"en": "Affirmation",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>ul>li.style3": {
		"ja": "履歴",
		"en": "History",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>ul>li.style4": {
		"ja": "お手伝い管理",
		"en": "Chore manager",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>ul>li.style5": {
		"ja": "楽しく目標達成",
		"en": "Achieve goals while having fun",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>p:1": {
		"ja": "ポイントを貯める方法やご褒美(ポイントの消費方法）の内容をご自身で設定頂けます.アイコンの設定なども行えます. 尚,実際のご褒美の実行についてはご自身で行って下さい.",
		"en": "You can set up redeem points(how to earn point) and reward(how to redeem point) by yourself. You can set up redeem points(how to earn point) and reward(how to redeem point) by yourself. You can set also small goal's icon by yourself. ",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>p:2": {
		"ja": "大きな目標設定をTOP画面へ表示することができます(アファーメーション:Affirmationの設定). 目標を可視化し、日々確認する事で目標達成へ繋げることができます.",
		"en": "App can display big goals on first screen, Settings Affirmation. You can stay motivated & achieve your goals by visualizing goals and checking them daily",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>p:3": {
		"ja": "アプリ内のカレンダーでは過去のポイントの履歴をご確認いただけます. しばらくして飽きてしまった時などに過去のアクティビティを確認してやる気アップ(モチベーションアップ)につなげて下さい.これまでの努力を目で確認することができます.",
		"en": "You can check the history of the points in the app's calendar. You can confirm all your efforts. When you get tired you can check the activity to motivate up.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>p:4": {
		"ja": "本アプリはご自身の目標管理だけでなく,お子様のお手伝い管理や目標管理にもお使い頂けると思います.",
		"en": "App can be used not only for your goal achievement management but also for children's Chore management.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#second>p:5": {
		"ja": "目標の達成をポイントと絡めることで,日々の努力をゲーム感覚で楽しく行うことができます. 楽しみながら目標達成を行ってください.",
		"en": "You can make continuous efforts as if collect rewards point. You can achieve goals while having fun.",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#cta>header>p": {
		"ja": "現在,iPhoneアプリのみご提供になります.androidバージョンは作成中です.",
		"en": "Under Construction android app",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#footer>section:1>h2": {
		"ja": "おすすめ",
		"en": "Others Apps",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"#footer>section:1>p>a": {
		"ja": "メートロゥ<br /> -フェスの予習,おすすめの出演アーティストを検索- ",
		"en": "Meetrow - App gathers lineup for Music Festivals",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"review": {
		"ja": "レビュー",
		"en": "Customer Reviews",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	},
	"user": {
		"ja": "投稿者：",
		"en": "by",
		"fr": "fr",
		"es": "es",
		"ar": "ar",
		"zh": "zh",
		"pt": "pt",
		"ru": "ru",
		"de": "de"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/asset/global.locale.json
// module id = 136
// module chunks = 0